export default {
  beforeEnter() {
    // 用件部分の表示など、フェードして現れる前に呼び出しておきたい処理
    const $form = $('div.wpcf7 > form');
    if ($form.find('.ajax-loader').length == 0) {
      $form.each(function () {
        wpcf7.init(this);
        if (wpcf7.cached) {
          wpcf7.refill(this);
        }
        wpcf7cf.initForm($(this)); // for conditional fields
      });
    }

    // 添付ファイル名の表示
    $('input[type="file"]').on('change', (e) => {
      $('#your-file-name').text(e.target.files[0].name)
    })
  }
}
